export default __webpack_public_path__ + "static/media/login-cover-img.84afee42.png";